
import {
  KELP_N_FRAMES,
  STATIC_N_FRAMES
} from "../../constants"
import { Container, Assets, AnimatedSprite, Texture } from "pixi.js"

export async function Foliage ({ foliageObjects }) {
  const foliage = new Container()
  
  await Assets.load("res/kelp.json")
  await Assets.load("res/kelp-top.json")
  await Assets.load("res/statics.json")

  const make = (name, nFrames) => {
    return [...Array(nFrames)].map((_, i) => Texture.from(`${name} ${i}`),)
  }
  
  const frames = {
    "kelp":     make("kelp", KELP_N_FRAMES),
    "kelp-top": make("kelp-top", KELP_N_FRAMES),
    "static":   make("statics", STATIC_N_FRAMES)
  }
  
  let foliages = []

  for (let i = 0; i < foliageObjects.length; ++ i) {
    const foliageObject = foliageObjects[i]
    let foliage = new AnimatedSprite(frames[foliageObject.id])
    foliage.anchor.set(0.5, 0.5)
    foliage.x = foliageObject.x
    foliage.y = foliageObject.y
    foliage.velocity = { x: 0, y: 0 }
    foliage.animationSpeed = 0.1
    foliage.currentFrame = foliageObject.startFrame
    
    if (foliageObject.animated)
      foliage.play()

    foliages.push(foliage)
  }

  foliage.addChild(...foliages)

  return { foliage }
}
